import _ from 'lodash';

import { ADWORDS_CONVERSION_LABEL } from 'ck-core-client/source/trackers/Adwords';
import { FACEBOOK_STANDARD_EVENT } from 'ck-core-client/source/trackers/Facebook';
import { Trackers } from 'ck-core-client/source/trackers/Trackers';

const CookieManager = require('../managers/CookieManager');

export async function addLeadEmail(email: string, trackers: Trackers, inIncentiveTest = false) {
	await CK.clientSockets.users.emit('addLeadFromEmailCaptureModal', {
		email,
		inIncentiveTest
	});

	trackers.trackAnalytic('ModalEmailAdded', {
		email
	});

	trackers.trackFacebookPixel(FACEBOOK_STANDARD_EVENT.LEAD, {
		value: 100,
		currency: _.upperCase(CK.fn.userCurrency())
	});

	trackers.trackAdwordsConversion(ADWORDS_CONVERSION_LABEL.EMAIL_LEAD_CAPTURE);

	CookieManager.mod().set('hideEmailCaptureModal', {
		hide: true
	});

	CookieManager.mod().set('submittedEmailCapture', {
		submitted: true
	});
}
